import { AbstractControl } from '@angular/forms';
import { BaseVariableControl } from './_base-control';



export class ScriptControl extends BaseVariableControl {

}
